import { createContext } from "react";

const AddressContext = createContext("no address found");

AddressContext.displayName = "AddressContext";

export default AddressContext;
